export default __webpack_public_path__ + "static/media/Migraine-1.33067012.jpg";